import { ObjectId } from '@/utils/objectid'

export const serialize = (value: any) => {
    if (value === undefined) return undefined

    return JSON.stringify(value, function (key, v) {
        const origValue = this![key]

        if (origValue instanceof Date) {
            return { $date: origValue.toISOString() }
        }

        if (
            // eslint-disable-next-line no-restricted-syntax
            origValue instanceof ObjectId ||
            origValue?._bsontype === 'ObjectID' ||
            origValue?._bsontype === 'ObjectId'
        ) {
            return { $oid: origValue.toString() }
        }

        return v
    })
}
